export const ROUTE_FORGOT_PASSWORD = 'forgot-password';
export const ROUTE_NOTIFICATION_SENT = 'forgot-password-sent';
export const ROUTE_CONFIRM_FORGOT_PASSWORD = 'confirm-forgot-password';
